import { HttpMethod, HttpStatus } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { FileHandlerConfiguration } from './file-service-types.js';
import { download, getFileInterface, isAllowedFile, isAllowedFileSize } from './file-service-utils.js';
class MemoryFileHandler {
    constructor() {
        this.memoryFiles = new Map();
        this.fileHandlerConfiguration = new FileHandlerConfiguration();
    }
    getPreviewURL(path) {
        return new Promise((resolve, reject) => {
            const file = this.memoryFiles.get(path);
            if (!file) {
                return reject();
            }
            resolve(URL.createObjectURL(file));
        });
    }
    preview(path) {
        void this.getPreviewURL(path)
            .then((url) => {
            window.open(url);
        });
    }
    // @ts-ignore - ignoring to avoid underscoring the unused vars
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    download(path, name, parameters = {}, method = HttpMethod.GET, options = {}) {
        return new Promise((resolve, reject) => {
            const file = this.memoryFiles.get(path);
            if (!file) {
                return reject();
            }
            resolve(download(file, name));
        });
    }
    clearMemoryFiles() {
        this.memoryFiles.clear();
    }
    getMemoryFiles() {
        return this.memoryFiles;
    }
    upload(file, events, maxFileSize) {
        return new Promise((resolve, reject) => {
            if (!isAllowedFile(file) || !isAllowedFileSize(file, maxFileSize)) {
                return reject(getFileInterface({ fileName: file.name, percentage: 0, state: 'invalid' }));
            }
            const { onProgress } = events;
            onProgress(getFileInterface({ fileName: file.name, percentage: 100, state: 'load' }));
            const basePath = `${window.location.origin}/resources/files`;
            const filename = `${new Date().getTime()}-${file.name}`;
            const path = `${basePath}/${filename}`;
            this.memoryFiles.set(path, file);
            resolve(getFileInterface({ fileName: file.name, path, percentage: 100, state: 'done' }));
        });
    }
    remove(path, name, onExecuteRemove) {
        const { removeResponseState } = this.fileHandlerConfiguration;
        if (!this.memoryFiles.has(path)) {
            return;
        }
        this.memoryFiles.delete(path);
        if (!isFunction(onExecuteRemove)) {
            return;
        }
        onExecuteRemove(name, path, HttpStatus.OK, (HttpStatus.OK === removeResponseState));
    }
    setConfiguration(fileHandlerConfiguration) {
        this.fileHandlerConfiguration = fileHandlerConfiguration;
    }
}
export { MemoryFileHandler, };
//# sourceMappingURL=memory-file-handler.js.map